import * as React from "react";
import CommonDeleteModal from "../../components/CustomDelete/CommonDeleteModal";
import { useRemovePermissionFromRoleMutation } from "../../services/appln";
import strings from "../../config/localization";

export default function PermissionRemove(props: any): any {
  const roleId = props.roleId;
  const permissionId = props.permissionId;

  const [removePermission, removePermParams] =
    useRemovePermissionFromRoleMutation();
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <CommonDeleteModal
        params={removePermParams}
        handleClickOpen={handleClickOpen}
        open={open}
        handleClose={handleClose}
        clickDeteleteApi={() => {
          removePermission({ permissionId: permissionId, roleId: roleId });
        }}
        deleteString={strings.remove}
        deleteTitle={strings.removePermissionTitle}
        deleteConfirmation={strings.removePermissionConfirmation}
        disagree={strings.disagree}
        agree={strings.agree}
      />
    </div>
  );
}
